import { ReactNode } from 'react'

import { useTrialStatus } from './hooks/useTrialStatus.js'
import { TrialExpiredModal } from './TrialExpired/TrialExpiredModal.js'

interface Props {
  children: ReactNode
}

export const TrialExpiredGate = ({ children }: Props) => {
  const { isTrialExpired, isLoading } = useTrialStatus()

  return (
    <>
      {children}
      {!isLoading && isTrialExpired && <TrialExpiredModal />}
    </>
  )
}
